import { PlusOutlined } from "@ant-design/icons";
import { Button, Divider, Input, Select, Space, Spin } from "antd";
import { getData, postData } from "apiServices/common";
import { useCallback, useEffect, useState } from "react";

export default function AddAndSelect({
  optionUrl,
  addUrl = null,
  onChange,
  value,
  optionResponseFormat,
  addResponseFormat = null,
  searchKeyword = "name",
  addKeyword = "name",
  placeholder = "Select this field",
}) {
  const [inputValue, setInputValue] = useState("");
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [adding, setAdding] = useState(false);

  const addItem = async () => {
    setAdding(true);
    try {
      const response = await postData(addUrl, {
        [addKeyword]: inputValue,
      });
      if (response) {
        if (addResponseFormat) {
          const resFormat = addResponseFormat(response);
          setOptions((prevOptions) => [resFormat, ...prevOptions]);
        }
        setInputValue("");
      }
    } catch (error) {
      console.error("Error adding item:", error);
    } finally {
      setAdding(false);
    }
  };

  const fetchOptions = useCallback(
    async (name = undefined) => {
      setLoading(true);
      try {
        const response = await getData(optionUrl, null, {
          [searchKeyword]: name,
          per_page: 10,
        });

        if (optionResponseFormat) {
          const formattedOptions = optionResponseFormat(response);
          setOptions(formattedOptions);
        } else {
          setOptions([]);
        }
      } catch (error) {
        console.error("Error fetching options:", error);
      } finally {
        setLoading(false);
      }
    },
    [optionUrl, optionResponseFormat, searchKeyword],
  );

  useEffect(() => {
    fetchOptions();
  }, [optionUrl, optionResponseFormat, fetchOptions]);

  return (
    <>
      <Select
        style={{ width: "100%" }}
        showSearch
        placeholder={placeholder}
        optionFilterProp="children"
        filterOption={false}
        onSearch={(value) => {
          fetchOptions(value);
        }}
        onChange={onChange}
        value={value}
        size="small"
        loading={loading}
        dropdownMatchSelectWidth={false}
        dropdownRender={(menu) => (
          <>
            {menu}
            {addUrl && addResponseFormat && (
              <>
                <Divider style={{ margin: "8px 0" }} />
                <Space style={{ padding: "0 8px 4px" }}>
                  <Input
                    style={{ width: "100%" }}
                    placeholder="Enter New Color"
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                  />
                  <Button
                    type="text"
                    icon={adding ? <Spin size="small" /> : <PlusOutlined />}
                    onClick={addItem}
                    disabled={adding}
                  >
                    Add
                  </Button>
                </Space>
              </>
            )}
          </>
        )}
        options={options}
      />
    </>
  );
}
